import * as types from "../constants/actionConstants";


const initialState = {
    flag: false
};

function versionsListLoadedFlagReducer(state = initialState, action) {
    switch (action.type) {
        case types.TEMPLATE_VERSIONS_LIST_LOADED_FLAG:
            return {flag: action.flag};
        default:
            return state;
    }
}

export default versionsListLoadedFlagReducer;